<template>
  <div class="row">

    <div class="col-md-8">
      <h3>All Goals</h3>
    </div>
    <div class="col-md-2 offset-md-2">
      <router-link :to="{ name: 'Add Goal'}" style="float:right">
        <p-button type="primary" round>
          Add Goal
        </p-button>
      </router-link>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-4">
              <el-select
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-sm-4 offset-sm-3">
              <div class="pull-right">
                <fg-input class="input-sm"
                          placeholder="Search"
                          v-model="searchQuery"
                          addon-right-icon="nc-icon nc-zoom-split">
                </fg-input>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
           
            <div class="card" v-for="(data, index) in queriedData" :key="index">
              <div class="card-body">
                <div style="border-bottom: 1px #ebeef5 solid; font-size">
                  <strong>{{data.description}}</strong>
                </div>
                <div class="row">
                  <div class="col-md-3" style="padding-top:12px;"><strong>Target Amount</strong> <br/>{{data.amount}}</div>
                  <div class="col-md-3" style="padding-top:12px;"><strong>Amount Saved</strong><br />{{data.saved}}</div>
                  <div class="col-md-3" style="padding-top:12px;"><strong>Status</strong> <br />{{data.status}}</div>
                  <div class="col-md-3">
                    <router-link :to="{ name: 'Update Goal', params: { id: data.id }}">
                      <p-button type="success" icon>
                        <i class="fa fa-edit"></i>
                      </p-button>
                    </router-link>
                    <p-button type="danger"  icon @click="handleDelete(index, data)">
                      <i class="fa fa-times"></i>
                    </p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import LineChart from 'src/components/UIComponents/Charts/LineChart'
  import BarChart from 'src/components/UIComponents/Charts/BarChart'
  import PieChart from 'src/components/UIComponents/Charts/PieChart'

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };
  export default {
    components: {
      PPagination 
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['description'],
        tableColumns: [
          {
            prop: 'description',
            label: 'Goals',
            minWidth: 150
          },
          {
            prop: 'amount',
            label: 'Target',
            minWidth: 80
          },
          {
            prop: 'saved',
            label: 'Saved'
          },
          {
            prop: 'start_date',
            label: 'Started',
          },
          {
            prop: 'due_date',
            label: 'Ending',
          },
          {
            prop: 'status',
            label: 'Status',
          },
        ],
        tableData: []
      }
    },
    methods: {
      handleDelete (index, row) {
        this.$http.delete('/goals/' + row.id)
        .then(response=>{
          if(response.data.created_at){
            
          }

          let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
          if (indexToDelete >= 0) {
            this.tableData.splice(indexToDelete, 1)
          }
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
          console.log(error)
        })
        
      },
      getGoals() {
        this.$http.get('/goals')
        .then(response => {

          response.data.map(function (e) {
            e.amount = new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(e.amount / 100).replace('NGN', '₦')
            
            e.saved = new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(e.saved / 100).replace('NGN', '₦')
          });
          this.tableData = response.data;
        })
        .catch(err => console.error(err));
		  }
    },

    mounted () {
      this.getGoals()
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
</style>
